// extracted by mini-css-extract-plugin
module.exports = {"areaText":"SitterNeighbourhood_areaText__60uuL"};